
import {
  Button,
  Dialog,
  DialogContent,
  DialogContentText,
  DialogTitle,
  FormControl,
  FormHelperText,
  InputLabel,
  MenuItem,
  Select,
  Slide,
  Switch,
  TextField,
} from "@mui/material";
import {
  CardCvcElement,
  CardExpiryElement,
  CardNumberElement,
  useElements,
  useStripe,
} from "@stripe/react-stripe-js";
import React, { useEffect, useState } from "react";
import { AiFillPlusSquare } from "react-icons/ai";
import { IoMdLock } from "react-icons/io";
import { PaymentAPI } from "../../api/PaymentAPI";
import MessageBox from "../../component/MessageBox";
import CardView from "./CardView";
import PopUpAlert from '../../component/PopUpAlert'

import { useSelector } from "react-redux";
import Loader from "../../component/Loader";

const cardStyle = {
  style: {
    base: {
      fontWeight: "400",
      fontFamily: "Roboto, Open Sans, Segoe UI, sans-serif",
      fontSize: "17px",
      fontSmoothing: "antialiased",
      ":-webkit-autofill": {
        color: "#fce883",
      },
    },
    invalid: {
      iconColor: "red",
      color: "red",
    },
  },
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="down" ref={ref} {...props} />;
});

const AddCardDetails = ({ startLoading, finishLoading, paymentMethods, defaultCard, setRefresh }) => {
  const stripe = useStripe();
  const elements = useElements();
  const [openForm, setOpenForm] = useState(false);
  const [formData, setFormData] = useState({});
   const [success, setSuccess] = useState({ status: "", data: "" });
   const [loading, setLoading] = useState(false)
  const [isAgree, setIsAgree] = useState(false);

  const [errorField, setErrorField] = useState({
    name: false,
    city: false,
    state: false,
    country: false,
    zipCode: false,
    address: false,
    unit: false,
  });
  const userInStore = useSelector((state) => state.user);

  const refreshTrue = () => {
    setRefresh(true);
  };

  const collectFormData = (e) => {
    setErrorField('')
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const attachPaymentMethod = async (pymtMethodId) => {
    const attachPaymentMethodInfo = {
      paymentMethodId: pymtMethodId,
      userId: userInStore?.userInfo?.userId,
      clubId: userInStore?.clubId,
    };
    const res = await PaymentAPI.postAttachPaymentMethodForUser(
      attachPaymentMethodInfo
    );
    return res.Data;
  };

  const handleCardForm = () => {
    // refreshTrue();
    setSuccess({ status: "", data: "" });
    setErrorField("");
    setFormData("");
    setIsAgree(false);
    setOpenForm(!openForm);
    setFormData({ country: 'US' });
  };
  const saveCard = async (event) => {
    event.preventDefault();

    if (!isAgree) {
      setSuccess({
        status: "error",
        data: "Please accept the term and conditions.",
      });
      return;
    }

    const errorFields = {};
    if (!formData.cardHolderName) {
      errorFields.name = true;
    }
    if (!formData.city) {
      errorFields.city = true;
    }
    if (!formData.country) {
      errorFields.country = true;
    }
    if (!formData.state) {
      errorFields.state = true;
    }
    if (!formData.zipCode) {
      errorFields.zipCode = true;
    }
    if (!formData.address) {
      errorFields.address = true;
    }

    setErrorField(errorFields);
    
    if (
      !formData.cardHolderName ||
      !formData.city ||
      !formData.country ||
      !formData.zipCode ||
      !formData.state ||
      !formData.address
    ) {
      return;
    }

    try {
      setLoading(true)
      const res = await PaymentAPI.postCreateSetupIntent({userId: userInStore?.userInfo?.userId,
        clubId: userInStore?.clubId});
        
      const result = await stripe.confirmCardSetup(res.Data, {
        payment_method: {
          card: elements.getElement(CardNumberElement),
          billing_details: {
            email: userInStore?.userInfo?.email,
            name: formData?.cardHolderName,
            address: {
              line1: formData?.address,
              city: formData?.city,
              country: formData?.country,
              state: formData?.state,
              postal_code: formData?.zipCode,
            },
          },
        },
      });

      if (result.error) {
        setSuccess({ status: "error", data: result.error.message });
        setLoading(false)
      } else {
        const r = await attachPaymentMethod(
          result?.setupIntent?.payment_method
        );
        setSuccess({
          status: "success",
          data: "Payment method was saved successfully!",
        });
        setLoading(false)
        refreshTrue();
      }
    } catch (error) {
      setLoading(false)

      setSuccess({ status: "error", data: error?.response?.data?.Data });
    }
  };

  return (
    <div className="pay-card-details-container">
     {loading && <Loader/>}
      <PopUpAlert type={success.status} message={success.data} />
    
      <div className="pay-card-details-card-items">
        {paymentMethods?.map((item, index) => (
          <CardView
            startLoading={startLoading}
            finishLoading={finishLoading}
            setSuccess={setSuccess}
            cardDetails={item}
            refreshTrue={refreshTrue}
            defaultCard={defaultCard}
            key={index}
            paymentMethodSize={paymentMethods.length}
          />
        ))}
        <div className="add-card-method-container">
          <AiFillPlusSquare
            data-testid="add-card-method-icon"
            onClick={handleCardForm}
            className="add-card-method-icon"
          />
        </div>
      </div>

      <Dialog
        open={openForm}
        maxWidth="sm"
        sx={{
          "@media (max-width:400px)": {
            maxWidth: "100%",
            boxSizing: 'border-box'
          },
        }}
        TransitionComponent={Transition}
        onClose={handleCardForm}
        aria-labelledby="alert-dialog-title"
        aria-describedby="alert-dialog-description"
      >
        <DialogTitle sx={{ fontWeight: 600 }} id="alert-dialog-title">
          {"Fill Your Card Details."}
        </DialogTitle>
        <DialogContent>
          <DialogContentText component={'span'} id="alert-dialog-description">
            {success.status !== "" && (
              <MessageBox data={success.data} status={success.status} />
            )}
            <form className="add_card_form_body" onSubmit={saveCard}>
              <div className="card_number_exp_date">
                <div className="card_number_input">
                  <CardNumberElement
                    onFocus={() => {
                      const rootStyle = getComputedStyle(
                        document.documentElement
                      );
                      const color = rootStyle
                        .getPropertyValue("--hoverColorBold")
                        .trim();
                      document.querySelector(
                        ".card_number_input"
                      ).style.outline = "2px solid " + color;
                    }}
                    onBlur={() =>
                    (document.querySelector(
                      ".card_number_input"
                    ).style.outline = "")
                    }
                    options={{ style: cardStyle.style }}
                  />
                </div>
                <div className="card_expiry_input">
                  <CardExpiryElement
                    onFocus={() => {
                      const rootStyle = getComputedStyle(
                        document.documentElement
                      );
                      const color = rootStyle
                        .getPropertyValue("--hoverColorBold")
                        .trim();
                      document.querySelector(
                        ".card_expiry_input"
                      ).style.outline = "2px solid" + color;
                    }}
                    onBlur={() =>
                    (document.querySelector(
                      ".card_expiry_input"
                    ).style.outline = "")
                    }
                    options={{ style: cardStyle.style }}
                  />
                </div>
                <div className="card_cvc_input">
                  <CardCvcElement
                    onFocus={() => {
                      const rootStyle = getComputedStyle(
                        document.documentElement
                      );
                      const color = rootStyle
                        .getPropertyValue("--hoverColorBold")
                        .trim();
                      document.querySelector(".card_cvc_input").style.outline =
                        "2px solid" + color;
                    }}
                    onBlur={() =>
                    (document.querySelector(".card_cvc_input").style.outline =
                      "")
                    }
                    options={{ style: cardStyle.style }}
                  />
                </div>
              </div>
              <div className="card_nickname">
                <TextField
                  size="small"
                  className="add-card-text-input"
                  name="cardHolderName"
                  error={errorField.name ? true : false}
                  helperText={errorField.name && "Name is required"}
                  sx={{ width: "100%" }}
                  id="cardHolderName"
                  label="Card Holder Name"
                  onChange={collectFormData}
                  value={formData?.cardHolderName || ""}
                  variant="outlined"
                />
              </div>
              <h1 className="billing_heading">Billing Address</h1>
              <div className="billing_address">
                <TextField
                  id="address"
                  className="add-card-text-input"
                  error={errorField.address ? true : false}
                  helperText={errorField.address && "Address is required"}
                  sx={{
                    width: "60%",
                    "@media (max-width:400px)": {
                      width: "100%", // Adjust width for small screens
                    },
                  }}
                  size="small"
                  name="address"
                  label="Address"
                  onChange={collectFormData}
                  value={formData?.address || ""}
                  variant="outlined"
                />
              </div>
              <div className="billing_address_city">
                <TextField
                  className="add-card-text-input"
                  id="city"
                  sx={{
                    width: "50%",
                    "@media (max-width:1000px)": {
                      width: "100%", // Adjust width for small screens
                    },
                  }}
                  error={errorField.city ? true : false}
                  helperText={errorField.city && "City is required"}
                  size="small"
                  name="city"
                  onChange={collectFormData}
                  value={formData?.city || ""}
                  label="City"
                />

                <TextField
                  id="state"
                  className="add-card-text-input"
                  sx={{
                    width: "25%",
                    "@media (max-width:1000px)": {
                      width: "100%",
                    },
                  }}
                  error={errorField.state ? true : false}
                  helperText={errorField.state && "State is required"}
                  size="small"
                  name="state"
                  onChange={collectFormData}
                  value={formData?.state || ""}
                  label="State"
                />

                <TextField
                  id="zipCode"
                  className="add-card-text-input"
                  sx={{
                    width: "25%",
                    "@media (max-width:1000px)": {
                      width: "100%",
                    },
                  }}
                  error={errorField.zipCode ? true : false}
                  helperText={errorField.zipCode && "Zip code is required"}
                  size="small"
                  name="zipCode"
                  onChange={collectFormData}
                  value={formData?.zipCode || ""}
                  label="Zip code"
                />
              </div>
              <div className="billing_country">
                <FormControl
                  className="billing_country_select_input"
                  size="small"
                  sx={{
                    width: "50%",
                    "@media (max-width:500px)": {
                      width: "100%",
                    },
                  }}
                >
                  <InputLabel id="demo-simple-select-label">Country</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    id="country"
                    value={formData?.country || ""}
                    error={errorField.country ? true : false}
                    label="Country"
                    name="country"
                    onChange={collectFormData}
                  >
                    <MenuItem value="US">United States</MenuItem>
                  </Select>
                  {errorField?.country && (
                    <FormHelperText error>Country is required</FormHelperText>
                  )}
                </FormControl>
              </div>
              <div className="agree-term-for-save-card">
                <Switch
                  checked={isAgree}
                  onClick={() => setIsAgree(!isAgree)}
                  color="primary"
                />
                <div className="agree-term-for-save-card-label">
                  Accept the term and conditions provided by Stripe
                </div>
              </div>
              <div className="save_and_cancel_btn">
                <Button
                  type="submit"
                  variant="contained"
                >
                  <IoMdLock className="card_save_button_icon" />
                  save
                </Button>

                <Button
                  color="error"
                  variant="outlined"
                  onClick={handleCardForm}
                >
                  cancel
                </Button>
              </div>
            </form>
          </DialogContentText>
        </DialogContent>
      </Dialog>
    </div>
  );
};

export default AddCardDetails;
